import { boolean, mixed, object, string } from 'yup';

import { validatePhoneNumber } from '@utils/validation';
import { nameValidation } from '@utils/validationSchemas';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_50_LENGTH } from '@constants/validationMessages';

const jobTitleField = string()
	.trim()
	.default('')
	.max(MAX_50_LENGTH, getMaxLengthErrMsg('Job Title', MAX_50_LENGTH));

export const schema = (isRequiredJobTitle: boolean) => object({
	jobTitle: isRequiredJobTitle
		? jobTitleField.required(validationErrMessages.jobTitle)
		: jobTitleField,
	firstName: nameValidation('First Name'),
	lastName: nameValidation('Last Name'),
	avatarId: string().nullable(),
	is2FA: boolean(),
	phoneNumber: mixed().when('is2FA', {
		is: (is2FA: boolean) => is2FA,
		then: string()
			.trim()
			.default('')
			.required(validationErrMessages.phoneNumber)
			.test('validatePhoneNumber', validationErrMessages.contactNumberFor2Fa, validatePhoneNumber),
		otherwise: string()
			.trim()
			.default('')
			.test('validatePhoneNumber', validationErrMessages.contactNumberFor2Fa, validatePhoneNumber),
	}),
});
